import { useState } from 'react'
import { downloadCsv, rowsToCsv, type CsvColumn } from '../lib/exportCsv'
import { type BtnSize, type BtnVariant } from '../lib/ui'
import { Button } from './ui/Button'

type Props<T> = {
  filename: string
  rows: T[]
  columns: CsvColumn<T>[]
  label?: string
  disabled?: boolean
  variant?: BtnVariant
  size?: BtnSize
  className?: string
  /** Вызывается перед экспортом (например, подгрузка данных). */
  onBeforeExport?: () => Promise<T[] | void> | T[] | void
}

export function ExportCsvButton<T>({
  filename,
  rows,
  columns,
  label = 'Экспорт CSV',
  disabled,
  variant = 'default',
  size = 'sm',
  className,
  onBeforeExport,
}: Props<T>) {
  const [busy, setBusy] = useState(false)

  const handleClick = async () => {
    if (disabled || busy || columns.length === 0) return
    setBusy(true)
    try {
      let data = rows
      if (onBeforeExport) {
        const next = await onBeforeExport()
        if (Array.isArray(next)) data = next
      }
      const csv = rowsToCsv(data, columns)
      downloadCsv(filename, csv)
    } finally {
      setBusy(false)
    }
  }

  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      className={className}
      disabled={disabled || busy || columns.length === 0}
      onClick={() => void handleClick()}
    >
      {busy ? 'Экспорт…' : label}
    </Button>
  )
}
